module.exports = __webpack_public_path__ + "img/add.21af7bcb.svg";